import type { Dict } from "../types";

export const publicBooking: Dict = {
  en: {

    // Booking toast messages (errorToast / successToast wrapper)
    "Booking.toast.appointmentCancelled": "Appointment cancelled",
    "Booking.toast.appointmentConfirmed": "Booking Request Sent",
    // Série récurrente (B-03, 2026-09-21)
    "Booking.toast.seriesPartiallyBooked": "Request sent: some dates are not available",
    "Booking.toast.seriesNoDatesAvailable": "None of the dates in this series are available at the selected time. Please choose another time.",
    "Booking.toast.seriesNeedsOneProfessional": "A series is booked with a single professional for all your services. Please choose a new time.",
    // Lot 4 (B-09, décision P2) : la demande retrouvée par sa clé a été annulée
    // ou refusée entre les deux clics. Jamais un faux écran de succès.
    "Booking.toast.previousRequestCancelled": "Your previous request for this time slot was cancelled. You can confirm again or choose another time.",
    "Booking.toast.authRequired": "Please sign in to continue",
    "Booking.toast.bookingTooLate": "It is too late to book this slot",
    "Booking.toast.cancelAppointmentFailed": "Could not cancel the appointment",
    "Booking.toast.confirmationEmailFailed": "Could not send the confirmation email",
    "Booking.toast.connectionError": "Connection issue, please retry",
    "Booking.toast.createAppointmentFailed": "Could not create the appointment",
    "Booking.toast.createServicesFailed": "Could not create the services",
    "Booking.toast.dismissDuplicateFailed": "Could not dismiss the duplicate",
    "Booking.toast.durationChangeEmailSent": "Update email sent to the client",
    "Booking.toast.invalidBookingInfo": "Booking information is invalid",
    "Booking.toast.hairdresserUnavailable": "This professional is no longer available. Please choose another.",
    "Booking.toast.serviceUnavailable": "This service is no longer available. Please choose another.",
    // Lot 6 (V-02) : le garde serveur a refusé parce que le salon a coupé la
    // réservation en ligne, ou réduit sa fenêtre, pendant que l'onglet était
    // ouvert. Chaînes serveur : online_booking_disabled_for_location,
    // booking_beyond_advance_window.
    "Booking.toast.onlineBookingDisabled": "Online booking is turned off for this salon. Please contact the salon directly.",
    "Booking.toast.beyondBookingWindow": "This date is no longer open for online booking. Please choose an earlier date.",
    "Booking.toast.markAttendanceFailed": "Could not update attendance",
    "Booking.toast.markCancellationSeenFailed": "Could not mark the cancellation as seen",
    "Booking.toast.mergeDuplicatesFailed": "Could not merge the duplicates",
    "Booking.toast.missingBookingDetails": "Booking details are missing",
    "Booking.toast.priceCalculating": "Calculating price...",
    "Booking.toast.recurrenceConfigured": "Recurrence configured",
    "Booking.toast.recurringCancelled": "Recurring appointments cancelled",
    "Booking.toast.rescheduleEmailFailed": "Could not send the reschedule email",
    "Booking.toast.salonNotFound": "Salon not found",
    "Booking.toast.salonValidationFailed": "Could not validate the salon",
    "Booking.toast.saveAppointmentFailed": "Could not save the appointment",
    "Booking.toast.selectEmployee": "Please select an employee",
    "Booking.toast.servicesApproved": "{n} services approved",
    "Booking.toast.servicesRejected": "{n} services rejected",
    "Booking.toast.slotTaken": "This slot is already taken",
    "Booking.toast.slotUnavailable": "This slot is no longer available",
    "Booking.toast.slotUnavailableTryAnother": "This slot is no longer available. Please choose another.",
    "Booking.toast.noProfessionalLeftForThisSlot":
      "This time was just booked. Here are the times still available.",
    "Booking.toast.namedEmployeeUnavailable":
      "{employee} is no longer available for {service} at this time. Please choose another time.",
    "Booking.toast.updateServicesFailed": "Could not update the services",
    "Booking.toast.updateAppointmentFailed": "Could not update the appointment",
    "Booking.toast.deleteAppointmentFailed": "Could not delete the appointment",
    "Booking.toast.appointmentStatusUpdated": "Appointment updated",
    "Booking.toast.appointmentDeleted": "Appointment deleted",

    // SalonSelection

    // Book
    "book.title": "Book your perfect appointment",
    "book.titleWithName": "book your perfect appointment",
    "book.myBookings": "My Bookings",
    "book.noEmployeeForAllServices": "No professional can perform all of your services. Please adjust your selection.",
    "book.noCandidatesForService": "No professional is available for {names}.",
    "book.signOut": "Sign Out",
    "book.step.service": "Service",
    "book.step.hairdresser": "Employee",
    "book.step.datetime": "Date & Time",
    "book.step.info": "Your Info",
    "book.step.review": "Review",
    "book.serviceProgress": "Service {i} of {n}",
    "book.button.back": "Back",
    "book.button.next": "Next",
    "book.button.confirming": "Confirming...",
    "book.toast.forfaitNoLongerOnline": "This package is no longer available online. Please choose your services again.",
    "book.authWall.title": "Sign in or sign up",
    "book.authWall.description": "Sign in or create an account to confirm your appointment.",
    "book.authWall.completeSignupDescription": "Complete your profile to confirm your appointment.",
    "book.missingData.title": "Booking Data Missing",
    "book.missingData.body": "Some booking information is missing. Please restart the booking process.",
    "book.missingData.restart": "Restart Booking",
    "book.button.confirm": "Confirm",
    "book.button.reschedule": "Reschedule Appointment",
    "book.hint.pickService": "Pick at least one service to continue",
    "book.hint.pickEmployee": "Pick a professional to continue",
    "book.hint.pickDate": "Pick a date to continue",
    "book.hint.pickTime": "Pick a time to continue",
    "book.toast.success": "Success!",
    "book.toast.confirmed": "Booking Request Sent",
    "book.toast.rescheduled": "Your appointment has been rescheduled.",
    "book.toast.error": "Booking Error",
    "book.toast.errorDesc": "We couldn't process your booking. Please try again.",
    "book.toast.overlappingError": "Time Slot Conflict",
    "book.toast.overlappingErrorDesc":
      "You already have an appointment at this time. Please choose a different time slot or employee.",
    "book.hairdresserAssigned": "Employee Assigned",
    "book.hasBeenAssigned": "has been assigned to your appointment",
    "book.haveBeenAssigned": "have been assigned to your appointment",
    "book.extendOutsideHours": "Appointments cannot be extended outside of the salon's opening hours",
    "book.errorLoadingSlots": "Failed to load available time slots",
    "book.step.location": "Location",
    "book.error.availabilityCheck": "Unable to check availability",
    "book.error.slotTaken": "Selected time slot is no longer available",
    "book.error.serviceCapacity": "This service has reached its maximum capacity for this time slot",
    "book.sameEmployeeQuestion": "Same employee for the other services?",
    "book.sameEmployeeQuestionWithName": "Keep {name} for the other services?",
    "book.sameEmployeeSubtitle": "Pick the same employee across all services or a different one for each.",
    "book.sameEmployeeYes": "Yes, same employee",
    "book.sameEmployeeNo": "No, pick someone else",
    // Fenêtre « Même employé ? » quand le premier choix est « N'importe qui »
    // (tâche 18) : « Non » veut dire « pas forcément le même », jamais
    // « obligatoirement différents ».
    "book.sameEmployeeQuestionAny": "The same professional for all your services?",
    "book.sameEmployeeSubtitleAny": "You can give all your services to one person, or let the salon choose for each service.",
    "book.sameEmployeeYesAny": "Yes, the same person",
    "book.sameEmployeeNoAny": "No, it does not matter",
    // Sauvetage du calendrier vide en « le même pour tout » (spec 5.13).
    "book.noSlotForSingleEmployee": "No professional can do all your services in a row. Would you accept different professionals?",
    "book.acceptDifferentEmployees": "Accept different professionals",
    // Écran de succès (spec 5.15) : {names} = tous les noms sauf le dernier,
    // joints par des virgules ; {last} = le dernier.
    "book.successWithEmployee": "Your appointment with {name}",
    // Série récurrente partiellement réservée (B-03, 2026-09-21)
    "success.series.booked": "Booked ({booked} of {total})",
    "success.series.unavailable": "Not available ({count})",
    "success.series.bookSeparately": "You can book these dates separately.",
    "book.successWithEmployees": "Your appointment with {names} and {last}",
    "book.cannotPerformService": "{name} doesn't perform {service}. You'll need to pick a different employee for it.",
    "book.cannotPerformServices": "{name} doesn't perform: {services}. You'll need to pick a different employee for those.",

    // Location Selection
    "location.selectLocation": "Select Location",
    "location.choosePreferred": "Choose your preferred salon location",
    "location.selectThisLocation": "Select This Location",
    "location.noLocationsAvailable": "No locations available for online booking",
    "location.bookingDisabled": "Online booking temporarily disabled",
    "location.bookingDisabledDescription":
      "Online booking is currently not available for this location. Please contact the salon directly to book an appointment.",
    "location.contactSalon": "Contact the Salon",
    "location.callUs": "Call us",
    "location.emailUs": "Email us",
    "location.visitWebsite": "Visit our website",
    "location.allLocations": "All locations",
    "location.originBadge": "Origin",
    "location.anyLocation.cardTitle": "Any location",
    "location.anyLocation.cardSubtitle": "We pick the location that is free at the time you want",
    "location.anyLocation.cardButton": "Choose this option",
    "location.anyLocation.notTogether": "Not offered at the same place as {{name}}",
    "location.anyLocation.notTogetherGeneric": "Not offered at the same place as your other services",
    "location.anyLocation.notFound": "Can't find your service?",
    "location.anyLocation.pickLocation": "Choose a location",
    "location.anyLocation.at": "At {{name}}, {{address}}",
    "location.anyLocation.atNoAddress": "At {{name}}",
    "location.anyLocation.fallbackTitle": "This time was just taken",
    "location.anyLocation.fallbackBody": "This time is no longer free at {{from}}. It is free at {{to}}, {{address}}, for {{total}}.",
    "location.anyLocation.fallbackBodyFrom": "This time is no longer free at {{from}}. It is free at {{to}}, {{address}}, starting at {{total}}.",
    "location.anyLocation.fallbackBodyNoPrice": "This time is no longer free at {{from}}. It is free at {{to}}, {{address}}.",
    "location.anyLocation.fallbackAccept": "Book at {{to}}",
    "location.anyLocation.fallbackAccepting": "One moment…",
    "location.anyLocation.fallbackDecline": "Choose another time",
    "book.recurringSuccess": "{count} appointments created and sent for approval.",
    "book.recurringSuccessWithConflicts": "{count} appointments created. {conflicts} dates had conflicts.",
    "book.recurringSeriesCreated": "Recurring series created",
    "book.recap.serviceCount": "{count} services",
    "book.recap.serviceCountSingular": "1 service",
    "book.recap.pickAtLeastOne": "Choose at least one service",
    "book.recap.expand": "Expand",
    "book.recap.collapse": "Collapse",
    // A total duration that is only a lower bound: a service left to the salon
    // whose qualified employees do not all take the same time.
    "book.durationFrom": "From {duration}",

    // Resolution failure surfacing (lot 8, tâche 6): `supabase.rpc` returns
    // errors in `{ error }` rather than throwing. These strings make a failed
    // price/duration resolution visible instead of it silently falling back.
    "book.priceResolution.failed": "We couldn't load your professional's exact price. The amount shown is a minimum.",
    "book.priceResolution.retry": "Try again",
    "book.durationResolution.failed": "We couldn't calculate your appointment's length. Please try again.",
    "book.durationResolution.retry": "Try again",

    // AppointmentSummary
    "summary.title": "Please Confirm Your Appointment",
    "summary.subtitle": "Please click the Confirm button at the bottom of the screen to confirm.",
    "summary.recurringTitle": "Recurring Appointment",
    "summary.recurringDescription": "This booking repeats every {interval} {type}{plural} until {endDate}.",
    "summary.additionalNotes": "Additional Notes",
    "summary.selectedTime": "Selected time:",

    // AppointmentSummary Additional Notes
    "summary.editContactInfo": "Edit Contact Information",
    "summary.editButton": "Edit",
    "summary.saveChanges": "Save Changes",
    "summary.fullName": "Full Name",
    "summary.emailAddress": "Email Address",
    "summary.phoneNumber": "Phone Number",
    "summary.additionalNotesLabel": "Additional Notes",
    "summary.additionalNotesPlaceholder": "Any special requests or preferences? (Optional)",
    "summary.appointmentDetails": "Appointment Details",
    "summary.service": "Service",
    "summary.services": "Services",
    "summary.section": "Section",
    "summary.hairdresser": "Employee",
    "summary.hairdressers": "Employees",
    "summary.date": "Date",
    "summary.time": "Time",
    "summary.duration": "Duration",
    "summary.total": "Total",
    "summary.contactInfo": "Contact Information",
    "summary.name": "Name",
    "summary.nameHint": "The salon needs it to identify your appointment.",
    "summary.nameRequired": "Please enter your name so the salon can identify your appointment.",
    // Lot 4 (V-10) : numéro saisi mais incomplet, dans un champ modifiable.
    "summary.phoneInvalid": "This number looks incomplete. Please correct it or leave the field empty.",
    "summary.email": "Email",
    "summary.phone": "Phone",
    "summary.optionalLabel": "optional",
    "summary.phoneSmsHint": "Add it to get SMS reminders. Otherwise everything goes by email.",
    "summary.savePhoneToProfile": "Save this number to my profile for next time",
    "summary.consentLabel": "I agree to receive appointment confirmations and reminders by email and SMS.",
    "summary.consentNote": "This does not include marketing emails.",
    "summary.consentRequired": "Please check this box to confirm your appointment. It is what lets us send you your confirmation and reminders.",
    // Lot 4 (B-19) : la lecture du consentement n'a pas encore répondu.
    "summary.consentStillLoading": "One moment, we are checking your communication preferences. Please try again in a few seconds.",
    "summary.consentSaveFailed": "We could not record your consent. Please try again.",
    "summary.notes": "Notes",
    "summary.totalPrice": "Total Price",

    // SalonSelection
    "Booking.nextAvailability": "Next available:",
    "Booking.fullyBookedWeek": "Fully booked this week",
    "Booking.today": "Today",
    "Booking.tomorrow": "Tomorrow",

    // Booking Sidebar
    "sidebar.bookingSummary": "Booking Summary",
    "sidebar.total": "Total",
    "sidebar.chooseService": "No service selected",
    "sidebar.chooseHairdresser": "No employee selected",
    "sidebar.chooseDateTime": "No date selected",
    // The deposit the client will be asked for, announced BEFORE they commit.
    // "at least" when the total is only a lower bound (a starting_from service).
    "sidebar.depositLine": "including a {amount} deposit to pay online",
    "sidebar.depositLineFrom": "including at least {amount} deposit to pay online",
    "sidebar.depositNonRefundableWindow": "This deposit is not refunded if you cancel less than {hours} hours ahead.",
    "sidebar.depositNonRefundable": "This deposit is not refundable.",
    // Le visiteur n'a pas à savoir que le salon ne paie plus son abonnement :
    // formulation neutre, orientée « appelez-les », comme pour la liste noire.
    "Booking.subscriptionInactiveTitle": "Online booking is unavailable",
    "Booking.subscriptionInactiveDescription": "This salon is not taking online appointments at the moment. Please contact them directly to book.",
    "deposit.loading": "Checking your deposit…",
    "deposit.paid.title": "Deposit received",
    "deposit.paid.body": "Your slot is held. The salon will confirm your appointment.",
    "deposit.settling.title": "Payment received",
    "deposit.settling.body": "We are finalising your booking. This usually takes a few seconds.",
    "deposit.required.title": "A deposit is required",
    "deposit.unavailable": "Your booking is pending. Payment is temporarily unavailable. Please try again.",
    "deposit.waiver.blocked": "A deposit must be paid before approval. The owner can explicitly waive it with a reason.",
    "deposit.waiver.open": "Waive deposit",
    "deposit.waiver.reason": "Reason for waiving the deposit",
    "deposit.waiver.reasonRequired": "Enter a reason for the waiver.",
    "deposit.waiver.submit": "Confirm deposit waiver",
    "deposit.waiver.checking": "Checking payment…",
    "deposit.waiver.failed": "The deposit could not be waived. Payment may be in progress or could not be verified. Please try again.",
    "deposit.waiver.success": "Deposit waived. You can now approve the appointment.",
    "deposit.waived.badge": "Deposit waived",
    "deposit.waived.reason": "Reason",
    "deposit.waived.by": "By",
    "deposit.waived.at": "On",
    "deposit.waived.unknownActor": "An owner",
    "deposit.required.body": "The salon asks for a {amount} deposit to hold this slot.",
    "deposit.required.bodyNoAmount": "The salon asks for a deposit to hold this slot.",
    "deposit.abandoned.title": "Deposit not paid",
    "deposit.holdNote": "Your booking stays pending until payment or an owner waiver. The payment time limit starts only when a payment page is available.",
    "deposit.pay": "Pay the deposit",
    "deposit.retryPay": "Try again",
    "deposit.retryCheck": "Check again",
    "deposit.nothing.title": "Nothing to pay",
    "deposit.nothing.body": "This booking does not require a deposit.",
    "deposit.unknown.title": "We could not check your deposit",
    "deposit.unknown.body": "Your booking is safe. Please try again in a moment.",
    "deposit.viewBookings": "View my bookings",

    // QuickBook errors

    // Landing Page
    "Landing.nav.home": "Home",

    // Welcome flow OAuth: salon match prompt after orphan signup
    "SalonMatch.singleTitle": "Hi {name}!",
    "SalonMatch.singleBody": "It looks like you might already be a client at {salon}. Is this your account?",
    "SalonMatch.multipleTitle": "Multiple salons found",
    "SalonMatch.multipleBody": "We found several salons where a {name} is already a client. Which one is yours?",
    "SalonMatch.confirmYes": "Yes, that's me",
    "SalonMatch.confirmNo": "No, that's not me",
    "SalonMatch.selectSalon": "Pick this salon",
    "SalonMatch.chooseFirst": "Pick a salon from the list first.",
    "SalonMatch.pick.title": "Which salon do you go to?",
    "SalonMatch.pick.body": "We could not find you at any salon. Pick the one you want to book with, and we will link your account to it.",
    "SalonMatch.pick.searchPlaceholder": "Search for a salon",
    "SalonMatch.pick.confirm": "Continue",
    "SalonMatch.pick.noneOfThese": "None of these",
    "SalonMatch.pick.noneNote": "Not a client at any of these? Your account already exists, and it will be linked on your first booking.",
    "SalonMatch.pick.confirmTitle": "Link your account to {salon}?",
    "SalonMatch.pick.confirmBody": "Your bookings and history will live with this salon. You will not be able to change it yourself afterwards.",
    "SalonMatch.pick.confirmYes": "Yes, link my account",
    "SalonMatch.pick.confirmBack": "Back to the list",

    // Public appointment confirmation page (Phase 3b)
    "Confirm.title": "Confirm your appointment",
    "Confirm.recap": "Appointment at {salon} on {date} at {time}",
    "Confirm.confirmButton": "Confirm my appointment",
    "Confirm.cancelButton": "Cancel my appointment",
    "Confirm.confirmed": "Your appointment is confirmed. Thank you!",
    "Confirm.declined": "Your appointment has been cancelled.",
    "Confirm.alreadyAnswered": "This appointment has already been handled.",
    "Confirm.expired": "This confirmation link has expired.",
    "Confirm.notFound": "This confirmation link is invalid.",
    "Confirm.loading": "Loading…",
    "Confirm.error": "Something went wrong. Please try again.",
  },
  fr: {

    // Booking toast messages (errorToast / successToast wrapper)
    "Booking.toast.appointmentCancelled": "Rendez-vous annulé",
    "Booking.toast.appointmentConfirmed": "Demande de réservation envoyée",
    // Série récurrente (B-03, 2026-09-21)
    "Booking.toast.seriesPartiallyBooked": "Demande envoyée : certaines dates ne sont pas disponibles",
    "Booking.toast.seriesNoDatesAvailable": "Aucune date de cette série n'est disponible à cette heure. Choisissez une autre heure.",
    "Booking.toast.seriesNeedsOneProfessional": "Une série se fait avec une seule personne pour tous vos services. Choisissez une nouvelle heure.",
    // Lot 4 (B-09, décision P2) : la demande retrouvée par sa clé a été annulée
    // ou refusée entre les deux clics. Jamais un faux écran de succès.
    "Booking.toast.previousRequestCancelled": "Votre demande précédente pour ce créneau a été annulée. Vous pouvez confirmer de nouveau ou choisir une autre heure.",
    "Booking.toast.authRequired": "Veuillez vous connecter pour continuer",
    "Booking.toast.bookingTooLate": "Il est trop tard pour réserver cette plage",
    "Booking.toast.cancelAppointmentFailed": "Impossible d'annuler le rendez-vous",
    "Booking.toast.confirmationEmailFailed": "Impossible d'envoyer le courriel de confirmation",
    "Booking.toast.connectionError": "Problème de connexion, veuillez réessayer",
    "Booking.toast.createAppointmentFailed": "Impossible de créer le rendez-vous",
    "Booking.toast.createServicesFailed": "Impossible de créer les services",
    "Booking.toast.dismissDuplicateFailed": "Impossible d'ignorer le doublon",
    "Booking.toast.durationChangeEmailSent": "Courriel de mise à jour envoyé au client",
    "Booking.toast.invalidBookingInfo": "Les informations de réservation sont invalides",
    "Booking.toast.hairdresserUnavailable": "Ce professionnel n'est plus disponible. Veuillez en choisir un autre.",
    "Booking.toast.serviceUnavailable": "Ce service n'est plus disponible. Veuillez en choisir un autre.",
    // Lot 6 (V-02) : le garde serveur a refusé parce que le salon a coupé la
    // réservation en ligne, ou réduit sa fenêtre, pendant que l'onglet était
    // ouvert. Chaînes serveur : online_booking_disabled_for_location,
    // booking_beyond_advance_window.
    "Booking.toast.onlineBookingDisabled": "La réservation en ligne est désactivée pour ce salon. Veuillez communiquer directement avec le salon.",
    "Booking.toast.beyondBookingWindow": "Cette date n'est plus ouverte à la réservation en ligne. Veuillez choisir une date plus proche.",
    "Booking.toast.markAttendanceFailed": "Impossible de mettre à jour la présence",
    "Booking.toast.markCancellationSeenFailed": "Impossible de marquer l'annulation comme vue",
    "Booking.toast.mergeDuplicatesFailed": "Impossible de fusionner les doublons",
    "Booking.toast.missingBookingDetails": "Les détails du rendez-vous sont manquants",
    "Booking.toast.priceCalculating": "Calcul du prix en cours...",
    "Booking.toast.recurrenceConfigured": "Récurrence configurée",
    "Booking.toast.recurringCancelled": "Rendez-vous récurrents annulés",
    "Booking.toast.rescheduleEmailFailed": "Impossible d'envoyer le courriel de modification",
    "Booking.toast.salonNotFound": "Salon introuvable",
    "Booking.toast.salonValidationFailed": "Impossible de valider le salon",
    "Booking.toast.saveAppointmentFailed": "Impossible d'enregistrer le rendez-vous",
    "Booking.toast.selectEmployee": "Veuillez sélectionner un employé",
    "Booking.toast.servicesApproved": "{n} services approuvés",
    "Booking.toast.servicesRejected": "{n} services refusés",
    "Booking.toast.slotTaken": "Cette plage horaire est déjà prise",
    "Booking.toast.slotUnavailable": "Cette plage horaire n'est plus disponible",
    "Booking.toast.slotUnavailableTryAnother": "Cette plage horaire n'est plus disponible. Veuillez en choisir une autre.",
    "Booking.toast.noProfessionalLeftForThisSlot":
      "Ce créneau vient d'être pris. Voici les heures encore disponibles.",
    "Booking.toast.namedEmployeeUnavailable":
      "{employee} n'est plus disponible pour {service} à cette heure. Veuillez choisir une autre heure.",
    "Booking.toast.updateServicesFailed": "Impossible de mettre à jour les services",
    "Booking.toast.updateAppointmentFailed": "Impossible de mettre à jour le rendez-vous",
    "Booking.toast.deleteAppointmentFailed": "Impossible de supprimer le rendez-vous",
    "Booking.toast.appointmentStatusUpdated": "Rendez-vous mis à jour",
    "Booking.toast.appointmentDeleted": "Rendez-vous supprimé",

    // SalonSelection

    // Book
    "book.title": "Réservez votre rendez-vous idéal",
    "book.titleWithName": "réservez votre rendez-vous idéal",
    "book.myBookings": "Mes réservations",
    "book.noEmployeeForAllServices": "Aucun professionnel ne peut faire l’ensemble de vos services. Modifiez votre sélection.",
    "book.noCandidatesForService": "Aucun professionnel n’est disponible pour {names}.",
    "book.signOut": "Se déconnecter",
    "book.step.service": "Service",
    "book.step.hairdresser": "Employé(e)",
    "book.step.datetime": "Date & Heure",
    "book.step.info": "Vos informations",
    "book.step.review": "Confirmation",
    "book.serviceProgress": "Service {i} sur {n}",
    "book.button.back": "Retour",
    "book.button.next": "Suivant",
    "book.button.confirming": "Confirmation en cours...",
    "book.toast.forfaitNoLongerOnline": "Ce forfait n'est plus offert en ligne. Veuillez choisir vos services de nouveau.",
    "book.authWall.title": "Authentification",
    "book.authWall.description": "Connectez-vous ou créez un compte pour confirmer votre rendez-vous.",
    "book.authWall.completeSignupDescription": "Complétez votre profil pour confirmer votre rendez-vous.",
    "book.missingData.title": "Données de réservation manquantes",
    "book.missingData.body": "Certaines informations de votre réservation sont manquantes. Veuillez recommencer le processus.",
    "book.missingData.restart": "Recommencer la réservation",
    "book.button.confirm": "Confirmer",
    "book.button.reschedule": "Reporter le rendez-vous",
    "book.hint.pickService": "Choisissez au moins un service pour continuer",
    "book.hint.pickEmployee": "Choisissez un professionnel pour continuer",
    "book.hint.pickDate": "Choisissez une date pour continuer",
    "book.hint.pickTime": "Choisissez une heure pour continuer",
    "book.toast.success": "Succès !",
    "book.toast.confirmed": "Demande de réservation envoyée",
    "book.toast.rescheduled": "Votre rendez-vous a été reporté.",
    "book.toast.error": "Erreur de réservation",
    "book.toast.errorDesc": "Impossible de traiter votre réservation. Veuillez réessayer.",
    "book.toast.overlappingError": "Conflit d'horaire",
    "book.toast.overlappingErrorDesc":
      "Vous avez déjà un rendez-vous à cette heure. Veuillez choisir un autre créneau horaire ou employé(e).",
    "book.hairdresserAssigned": "Employé(e) assigné(e)",
    "book.hasBeenAssigned": "a été assigné(e) à votre rendez-vous",
    "book.haveBeenAssigned": "ont été assigné(e)s à votre rendez-vous",
    "book.extendOutsideHours":
      "Les rendez-vous ne peuvent pas être étendus en dehors des heures d'ouverture du salon",
    "book.errorLoadingSlots": "Échec du chargement des créneaux horaires disponibles",
    "book.step.location": "Emplacement",
    "book.error.availabilityCheck": "Impossible de vérifier la disponibilité",
    "book.error.slotTaken": "Le créneau horaire sélectionné n'est plus disponible",
    "book.error.serviceCapacity": "Ce service a atteint sa capacité maximale pour ce créneau",
    "book.sameEmployeeQuestion": "Même employé(e) pour les autres services ?",
    "book.sameEmployeeQuestionWithName": "Garder {name} pour les autres services ?",
    "book.sameEmployeeSubtitle": "Choisissez le même employé(e) pour tous les services ou un(e) différent(e) pour chacun.",
    "book.sameEmployeeYes": "Oui, même employé(e)",
    "book.sameEmployeeNo": "Non, en choisir un(e) autre",
    // Fenêtre « Même employé ? » quand le premier choix est « N'importe qui »
    // (tâche 18) : « Non » veut dire « pas forcément le même », jamais
    // « obligatoirement différents ».
    "book.sameEmployeeQuestionAny": "Le même professionnel pour tous vos services ?",
    "book.sameEmployeeSubtitleAny": "Vous pouvez confier tous vos services à une seule personne, ou laisser le salon choisir pour chaque service.",
    "book.sameEmployeeYesAny": "Oui, la même personne",
    "book.sameEmployeeNoAny": "Non, peu importe",
    // Sauvetage du calendrier vide en « le même pour tout » (spec 5.13).
    "book.noSlotForSingleEmployee": "Aucun professionnel ne peut enchaîner tous vos services. Acceptez-vous des professionnels différents ?",
    "book.acceptDifferentEmployees": "Accepter des professionnels différents",
    // Écran de succès (spec 5.15) : {names} = tous les noms sauf le dernier,
    // joints par des virgules ; {last} = le dernier.
    "book.successWithEmployee": "Votre rendez-vous avec {name}",
    // Série récurrente partiellement réservée (B-03, 2026-09-21)
    "success.series.booked": "Réservés ({booked} sur {total})",
    "success.series.unavailable": "Non disponibles ({count})",
    "success.series.bookSeparately": "Vous pouvez réserver ces dates séparément.",
    "book.successWithEmployees": "Votre rendez-vous avec {names} et {last}",
    "book.cannotPerformService": "{name} ne fait pas {service}. Vous devrez choisir un(e) autre employé(e) pour ce service.",
    "book.cannotPerformServices": "{name} ne fait pas : {services}. Vous devrez choisir un(e) autre employé(e) pour ces services.",

    // Location Selection
    "location.selectLocation": "Sélectionner l'emplacement",
    "location.choosePreferred": "Choisissez votre emplacement de salon préféré",
    "location.selectThisLocation": "Sélectionner cet emplacement",
    "location.noLocationsAvailable": "Aucun emplacement disponible pour la réservation en ligne",
    "location.bookingDisabled": "Réservation en ligne désactivée temporairement",
    "location.bookingDisabledDescription":
      "La réservation en ligne n'est pas disponible pour cet emplacement actuellement. Veuillez contacter le salon directement pour prendre rendez-vous.",
    "location.contactSalon": "Contacter le salon",
    "location.callUs": "Appelez-nous",
    "location.emailUs": "Écrivez-nous",
    "location.visitWebsite": "Visiter notre site web",
    "location.allLocations": "Tous les emplacements",
    "location.originBadge": "Origine",
    "location.anyLocation.cardTitle": "N'importe quel emplacement",
    "location.anyLocation.cardSubtitle": "Nous choisissons pour vous l'emplacement libre à l'heure voulue",
    "location.anyLocation.cardButton": "Choisir cette option",
    "location.anyLocation.notTogether": "Pas offert au même endroit que {{name}}",
    "location.anyLocation.notTogetherGeneric": "Pas offert au même endroit que vos autres services",
    "location.anyLocation.notFound": "Vous ne trouvez pas votre service ?",
    "location.anyLocation.pickLocation": "Choisir un emplacement",
    "location.anyLocation.at": "Chez {{name}}, {{address}}",
    "location.anyLocation.atNoAddress": "Chez {{name}}",
    "location.anyLocation.fallbackTitle": "Cette heure vient d'être prise",
    "location.anyLocation.fallbackBody": "Cette heure n'est plus libre chez {{from}}. Elle l'est chez {{to}}, {{address}}, pour {{total}}.",
    "location.anyLocation.fallbackBodyFrom": "Cette heure n'est plus libre chez {{from}}. Elle l'est chez {{to}}, {{address}}, à partir de {{total}}.",
    "location.anyLocation.fallbackBodyNoPrice": "Cette heure n'est plus libre chez {{from}}. Elle l'est chez {{to}}, {{address}}.",
    "location.anyLocation.fallbackAccept": "Réserver chez {{to}}",
    "location.anyLocation.fallbackAccepting": "Un instant…",
    "location.anyLocation.fallbackDecline": "Choisir une autre heure",
    "book.recurringSuccess": "{count} rendez-vous créés et envoyés pour approbation.",
    "book.recurringSuccessWithConflicts": "{count} rendez-vous créés. {conflicts} dates avaient des conflits.",
    "book.recurringSeriesCreated": "Série récurrente créée",
    "book.recap.serviceCount": "{count} services",
    "book.recap.serviceCountSingular": "1 service",
    "book.recap.pickAtLeastOne": "Choisissez au moins un service",
    "book.recap.expand": "Déplier",
    "book.recap.collapse": "Replier",
    // Durée totale qui n'est qu'une borne basse : un service laissé au choix
    // du salon dont les professionnels qualifiés n'ont pas tous la même durée.
    "book.durationFrom": "Dès {duration}",

    // Échecs de résolution visibles (lot 8, tâche 6) : `supabase.rpc` rend
    // ses erreurs dans `{ error }` plutôt que de lever. Ces chaînes rendent
    // visible un échec de résolution de prix ou de durée qui retombait
    // jusqu'ici en silence sur le catalogue.
    "book.priceResolution.failed": "Le prix exact de votre professionnel n'a pas pu être chargé. Le montant affiché est un minimum.",
    "book.priceResolution.retry": "Réessayer",
    "book.durationResolution.failed": "La durée de votre rendez-vous n'a pas pu être calculée. Veuillez réessayer.",
    "book.durationResolution.retry": "Réessayer",

    // AppointmentSummary
    "summary.title": "Veuillez confirmer votre rendez-vous",
    "summary.subtitle": "Veuillez cliquer sur le bouton Confirmer en bas de l'écran pour confirmer.",
    "summary.recurringTitle": "Rendez-vous récurrent",
    "summary.recurringDescription":
      "Cette réservation se répète tous les {interval} {type}{plural} jusqu'au {endDate}.",
    "summary.additionalNotes": "Notes supplémentaires",
    "summary.selectedTime": "Heure sélectionnée :",
    "summary.editContactInfo": "Modifier les coordonnées",
    "summary.editButton": "Modifier",
    "summary.saveChanges": "Sauvegarder les modifications",
    "summary.fullName": "Nom complet",
    "summary.emailAddress": "Adresse courriel",
    "summary.phoneNumber": "Numéro de téléphone",
    "summary.additionalNotesLabel": "Notes supplémentaires",
    "summary.additionalNotesPlaceholder": "Des demandes ou préférences particulières ? (Optionnel)",
    "summary.appointmentDetails": "Détails du rendez-vous",
    "summary.service": "Service",
    "summary.services": "Services",
    "summary.section": "Section",
    "summary.hairdresser": "Employé(e)",
    "summary.hairdressers": "Employé(e)s",
    "summary.date": "Date",
    "summary.time": "Heure",
    "summary.duration": "Durée",
    "summary.total": "Total",
    "summary.contactInfo": "Coordonnées",
    "summary.name": "Nom",
    "summary.nameHint": "Le salon en a besoin pour reconnaître votre rendez-vous.",
    "summary.nameRequired": "Veuillez indiquer votre nom pour que le salon puisse reconnaître votre rendez-vous.",
    // Lot 4 (V-10) : numéro saisi mais incomplet, dans un champ modifiable.
    "summary.phoneInvalid": "Ce numéro semble incomplet. Corrigez-le ou laissez le champ vide.",
    "summary.email": "Courriel",
    "summary.phone": "Téléphone",
    "summary.optionalLabel": "optionnel",
    "summary.phoneSmsHint": "Ajoutez-le pour recevoir vos rappels par SMS. Sinon tout passe par courriel.",
    "summary.savePhoneToProfile": "Enregistrer ce numéro sur mon profil pour la prochaine fois",
    "summary.consentLabel": "J'accepte de recevoir les confirmations et rappels de rendez-vous par courriel et texto.",
    "summary.consentNote": "Ceci n'inclut pas les courriels promotionnels.",
    "summary.consentRequired": "Veuillez cocher cette case pour confirmer votre rendez-vous. C'est elle qui nous permet de vous envoyer votre confirmation et vos rappels.",
    // Lot 4 (B-19) : la lecture du consentement n'a pas encore répondu.
    "summary.consentStillLoading": "Un instant, nous vérifions vos préférences de communication. Veuillez réessayer dans quelques secondes.",
    "summary.consentSaveFailed": "Nous n'avons pas pu enregistrer votre consentement. Veuillez réessayer.",
    "summary.notes": "Notes",
    "summary.totalPrice": "Prix total",

    // SalonSelection
    "Booking.nextAvailability": "Prochaine dispo :",
    "Booking.fullyBookedWeek": "Complet cette semaine",
    "Booking.today": "aujourd'hui",
    "Booking.tomorrow": "demain",

    // Booking Sidebar
    "sidebar.bookingSummary": "Résumé de la réservation",
    "sidebar.total": "Total",
    "sidebar.chooseService": "Aucun service sélectionné",
    "sidebar.chooseHairdresser": "Aucun employé sélectionné",
    "sidebar.chooseDateTime": "Aucune date sélectionnée",
    // L'acompte qui sera demandé au client, annoncé AVANT qu'il s'engage.
    // « au moins » quand le total n'est qu'une borne basse (service « dès »).
    "sidebar.depositLine": "dont {amount} d'acompte à régler en ligne",
    "sidebar.depositLineFrom": "dont au moins {amount} d'acompte à régler en ligne",
    "sidebar.depositNonRefundableWindow": "Cet acompte n'est pas remboursé si vous annulez moins de {hours} heures à l'avance.",
    "sidebar.depositNonRefundable": "Cet acompte n'est pas remboursable.",
    // Le visiteur n'a pas à savoir que le salon ne paie plus son abonnement :
    // formulation neutre, orientée « appelez-les », comme pour la liste noire.
    "Booking.subscriptionInactiveTitle": "La réservation en ligne n'est pas disponible",
    "Booking.subscriptionInactiveDescription": "Ce salon ne prend pas de rendez-vous en ligne pour le moment. Veuillez le contacter directement pour réserver.",
    "deposit.loading": "Vérification de votre acompte…",
    "deposit.paid.title": "Acompte reçu",
    "deposit.paid.body": "Votre créneau est retenu. Le salon confirmera votre rendez-vous.",
    "deposit.settling.title": "Paiement reçu",
    "deposit.settling.body": "Nous finalisons votre réservation. Cela prend habituellement quelques secondes.",
    "deposit.required.title": "Un acompte est demandé",
    "deposit.unavailable": "Votre réservation est en attente. Le paiement est temporairement indisponible. Veuillez réessayer.",
    "deposit.waiver.blocked": "L’acompte doit être réglé avant l’approbation. Le propriétaire peut accorder une dispense explicite avec un motif.",
    "deposit.waiver.open": "Dispenser de l’acompte",
    "deposit.waiver.reason": "Motif de la dispense",
    "deposit.waiver.reasonRequired": "Veuillez saisir le motif de la dispense.",
    "deposit.waiver.submit": "Confirmer la dispense",
    "deposit.waiver.checking": "Vérification du paiement…",
    "deposit.waiver.failed": "La dispense est impossible. Le paiement est peut-être en cours ou n’a pas pu être vérifié. Veuillez réessayer.",
    "deposit.waiver.success": "Dispense enregistrée. Vous pouvez maintenant approuver le rendez-vous.",
    "deposit.waived.badge": "Acompte dispensé",
    "deposit.waived.reason": "Motif",
    "deposit.waived.by": "Par",
    "deposit.waived.at": "Le",
    "deposit.waived.unknownActor": "Un propriétaire",
    "deposit.required.body": "Le salon demande un acompte de {amount} pour retenir ce créneau.",
    "deposit.required.bodyNoAmount": "Le salon demande un acompte pour retenir ce créneau.",
    "deposit.abandoned.title": "Acompte non réglé",
    "deposit.holdNote": "Votre réservation reste en attente du paiement ou d’une dispense du propriétaire. Le délai de paiement commence seulement lorsqu’une page de paiement est disponible.",
    "deposit.pay": "Payer l'acompte",
    "deposit.retryPay": "Réessayer",
    "deposit.retryCheck": "Vérifier à nouveau",
    "deposit.nothing.title": "Rien à payer",
    "deposit.nothing.body": "Cette réservation n'exige pas d'acompte.",
    "deposit.unknown.title": "Nous n'avons pas pu vérifier votre acompte",
    "deposit.unknown.body": "Votre réservation n'est pas perdue. Réessayez dans un instant.",
    "deposit.viewBookings": "Voir mes rendez-vous",

    // QuickBook errors

    // Landing Page
    "Landing.nav.home": "Accueil",

    // Welcome flow OAuth : prompt après inscription orpheline
    "SalonMatch.singleTitle": "Salut {name} !",
    "SalonMatch.singleBody": "Vous avez déjà un compte chez {salon}. C'est bien le vôtre ?",
    "SalonMatch.multipleTitle": "Plusieurs salons trouvés",
    "SalonMatch.multipleBody": "Plusieurs salons comptent déjà {name} parmi leurs clients. Lequel est le vôtre ?",
    "SalonMatch.confirmYes": "Oui, c'est moi",
    "SalonMatch.confirmNo": "Non, c'est quelqu'un d'autre",
    "SalonMatch.selectSalon": "Choisir ce salon",
    "SalonMatch.chooseFirst": "Choisissez d'abord un salon dans la liste.",
    "SalonMatch.pick.title": "Chez quel salon allez-vous ?",
    "SalonMatch.pick.body": "Aucun salon ne vous connaît encore. Choisissez celui où vous voulez prendre rendez-vous, on rattachera votre compte à ce salon.",
    "SalonMatch.pick.searchPlaceholder": "Chercher un salon",
    "SalonMatch.pick.confirm": "Continuer",
    "SalonMatch.pick.noneOfThese": "Aucun de ces salons",
    "SalonMatch.pick.noneNote": "Vous n'avez de compte chez aucun de ces salons ? Votre compte est déjà créé : il sera rattaché tout seul à votre première réservation.",
    "SalonMatch.pick.confirmTitle": "Rattacher votre compte à {salon} ?",
    "SalonMatch.pick.confirmBody": "Vos rendez-vous et votre historique vivront chez ce salon. Vous ne pourrez pas en changer vous-même ensuite.",
    "SalonMatch.pick.confirmYes": "Oui, rattacher mon compte",
    "SalonMatch.pick.confirmBack": "Revenir à la liste",

    // Page publique de confirmation de rendez-vous (Phase 3b)
    "Confirm.title": "Confirmez votre rendez-vous",
    "Confirm.recap": "Rendez-vous chez {salon} le {date} à {time}",
    "Confirm.confirmButton": "Confirmer mon rendez-vous",
    "Confirm.cancelButton": "Annuler mon rendez-vous",
    "Confirm.confirmed": "Votre rendez-vous est confirmé. Merci!",
    "Confirm.declined": "Votre rendez-vous a été annulé.",
    "Confirm.alreadyAnswered": "Ce rendez-vous a déjà été traité.",
    "Confirm.expired": "Ce lien de confirmation a expiré.",
    "Confirm.notFound": "Ce lien de confirmation n'est pas valide.",
    "Confirm.loading": "Chargement…",
    "Confirm.error": "Une erreur est survenue. Réessayez.",
  },
};
